module.exports = __webpack_public_path__ + "assets/b27.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b27.png
// module id = 613
// module chunks = 0